import React, {Component} from 'react'

import Flickity from 'flickity'
import {Prodibi} from './'
import {flickitySlideStyle} from './../styles'
import { getAverageColor } from './../helpers/getAverageColor'


export default class SimpleSlider extends Component {
  state = {
    color: []
  }

  componentDidMount () {
    this.initSlider()
  }

  componentWillReceiveProps({images}) {
    if (images !== this.props.images) {
      this.flktySlides.destroy()
      this.timer = setTimeout(() => {
        this.initSlider()
      }, 200)
    }
  }

  componentWillUnmount () {
    this.flktySlides.destroy()
  }

  initSlider = () => {
    this.flktySlides = new Flickity( this.slider, {
      lazyLoad: 1,
      pageDots: this.props.images.length > 1,
    })

    for(const image of this.props.images){
      getAverageColor(image.url).then((data) => { 
        this.setState({
          color: [...this.state.color, data]
        })
      }).catch((e) => {
        console.log(e)
      })
    }

    // Reinit Slider (to prevent adding .is-selected)
    this.flktySlides.reloadCells()
    setTimeout(() => {
      this.flktySlides.reloadCells()
    }, 600)
  }

  shouldComponentUpdate({images}, {color}) {
    return images !== this.props.images || this.state.color !== color
  }

  render () {
    const {images} = this.props
    const {color} = this.state
    return (
      <div className="flickity-slider-parent" ref={(flickity) => this.slider = flickity}>
        {
          images.map((image, index) => (
            <div className={`flickity-slide template-picture template-picture--${image.picture_position} ${ flickitySlideStyle(  image.type === 'file' ? image.url : '', color[index] ) }`} key={index}>
              {
                image.type === 'prodibi' && 
                <Prodibi
                  id={image.reference}
                  width={image.width}
                  height={image.height}
                />
              }
            </div>
          ))
        }
    </div>
    )
  }
} 



// WEBPACK FOOTER //
// ./src/components/SimpleSlider.js